import React from 'react';

interface ModalBackdropProps {
  children: React.ReactNode;
  blur?: string;
}

export default function ModalBackdrop({ children, blur = 'backdrop-blur-md' }: ModalBackdropProps) {
  return (
    <div
      className={`fixed left-0 top-0 z-40 flex h-[100vh] w-[100vw] items-center justify-center ${blur}`}
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
    >
      {children}
    </div>
  );
}
